import React from "react";
import {
  AuthType,
  FeedbackLanguage,
  FeedbackLoader,
  StyleRoot,
} from "@atmt/feedback-component-web";
import { FeedbackEnvironment } from "@atmt/feedback-trigger-library";

const getFeedbackEnvironment = (apiBase) => {
  if (!apiBase) return FeedbackEnvironment?.PRD;
  if (apiBase.includes(".dev.")) return FeedbackEnvironment?.DEV;
  if (apiBase.includes(".qa.")) return FeedbackEnvironment?.QA;
  return FeedbackEnvironment?.PRD;
};

const FeedbackDialog = ({ atmtAuth, userId }) => {
  if (!atmtAuth) return null;

  const feedbackEnvironment = getFeedbackEnvironment(atmtAuth.apiBase);

  return (
    <StyleRoot id="feedback-dialog-root">
      <FeedbackLoader
        appId={atmtAuth.productId}
        baseUrl={feedbackEnvironment}
        disableAnnouncements
        dialog={false}
        environment={feedbackEnvironment}
        userId={userId}
        useWidgetConfiguration
        useWidgetConfig={true}
        disableSurveys={false}
        languageCode={FeedbackLanguage?.ENGLISH}
        countryCode={"US"}
        authentication={{
          type: AuthType.atmtAuth,
          config: {
            consumerId: atmtAuth.consumerId,
            atmtToken: atmtAuth.atmtToken,
          },
        }}
      />
    </StyleRoot>
  );
};

export default FeedbackDialog;
